/* 我的文件 */
export default {
  // 查询过期文件列表
  getExpiredFiles: {
    url: "/myFiles/getExpiredFiles",
    method: "post"
  },
  // 删除失效文件
  deleteExpiredFile: {
    url: "/myFiles/deleteExpiredFile",
    method: "post"
  },
  // 重置过期文件
  resetExpiredFile: {
    url: "/myFiles/resetExpiredFile",
    method: "post"
  },
  // 获取我过期文件的数量
  getMyExpiredFilesCount: {
    url: "/myFiles/getMyExpiredFilesCount",
    method: "get"
  },
  // 收藏文件
  addFavoriteFile: {
    url: "/myFiles/addFavoriteFile",
    method: "post"
  },
  // 取消收藏文件
  removeFavoriteFile: {
    url: "/myFiles/removeFavoriteFile",
    method: "post"
  },
  // 获取收藏文件列表
  getFavoriteFiles: {
    url: "/myFiles/getFavoriteFiles",
    method: "post"
  },
  // 获取将要过期的文件数量
  getSoonlyExpiredFilesCount: {
    url: "/myFiles/getSoonlyExpiredFilesCount",
    method: "post"
  },
  // 获取我的配置
  getMySetting: {
    url: "/myFiles/getMySetting",
    method: "get"
  },
  // 新增我的配置
  addMySetting: {
    url: "/myFiles/addMySetting",
    method: "post"
  },
  // 获取我上传文件类型数量
  getMyFilesTypeCount: {
    url: "/myFiles/getMyFilesTypeCount",
    method: "get"
  },
  // 获取我的项目
  getMyProjects: {
    url: "/myFiles/getMyProjects",
    method: "post"
  },
}
